/**
 * API endpoint templates and paths.
 * Use these functions to generate consistent API URLs.
 */

import { getIdentifierConfig } from "@/lib/identifier-config";

/** Get the configured path segment (e.g., "threads" or "projects") */
const getPathSegment = () => getIdentifierConfig().pathSegment;

/** Thread management endpoints */
export const API_ENDPOINTS = {
  /** Generate search endpoint */
  threadSearch: () => `/llm/${getPathSegment()}/search`,

  /** Create project endpoint (database router) */
  CREATE_THREAD: "/db/create-project",

  /** Delete project endpoint (database router) */
  deleteThread: (threadId: string) => `/db/${getPathSegment()}/${threadId}`,

  /** Generate thread detail endpoint */
  threadDetail: (threadId: string) => `/llm/${getPathSegment()}/${threadId}`,

  /** Generate thread endpoint (alternative format) */
  thread: (threadId: string) => `/${getPathSegment()}/${threadId}`,

  /** Generate streaming endpoint for thread agent */
  threadStream: (threadId: string) => `/llm/${getPathSegment()}/${threadId}/agent/stream`,
} as const;
